import React, { useState } from 'react';
import { SKYX_MODAL_CLOSE } from './SkyxNewModalClose.styles';

const skyxNewQuickBetChipChrome = {
  background: 'linear-gradient(180deg, #301869 0%, #1F0D47 100%)',
  border: 'rgba(147,92,255,0.5)',
  color: '#ffffff',
  boxShadow: '0 2px 3px rgba(0,0,0,0.35), inset 0 1px 0 rgba(255,255,255,0.1)',
} as const;

export interface SkyxNewModalCloseButtonProps {
  onClick: () => void;
  ariaLabel: string;
  mobile?: boolean;
  style?: React.CSSProperties;
  /** Keeps chat panel dismiss sound routing (`data-skyx-chat-close`). */
  chatClose?: boolean;
  variant?: 'default' | 'chip';
}

/** Circular purple close control — same as Auto Play popup (skyx_new). */
export const SkyxNewModalCloseButton: React.FC<
  SkyxNewModalCloseButtonProps
> = ({
  onClick,
  ariaLabel,
  mobile = false,
  style,
  chatClose = false,
  variant = 'default',
}) => {
  const [hovered, setHovered] = useState(false);
  const [active, setActive] = useState(false);
  const isChip = variant === 'chip';

  return (
    <button
      type="button"
      className="autoplay-3d-btn"
      data-skyx-modal-close
      data-skyx-chat-close={chatClose ? true : undefined}
      style={{
        ...SKYX_MODAL_CLOSE.button,
        ...(mobile ? SKYX_MODAL_CLOSE.buttonMobile : {}),
        ...(isChip
          ? {
              background: skyxNewQuickBetChipChrome.background,
              border: `1px solid ${skyxNewQuickBetChipChrome.border}`,
              color: skyxNewQuickBetChipChrome.color,
              boxShadow: skyxNewQuickBetChipChrome.boxShadow,
              transition: 'filter 0.12s ease, transform 0.08s ease',
              ...(hovered ? SKYX_MODAL_CLOSE.buttonChipHover : {}),
            }
          : hovered
            ? SKYX_MODAL_CLOSE.buttonHover
            : {}),
        ...style,
      }}
      onClick={onClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => {
        setHovered(false);
        setActive(false);
      }}
      onMouseDown={() => setActive(true)}
      onMouseUp={() => setActive(false)}
      aria-label={ariaLabel}
    >
      <span
        style={{
          ...SKYX_MODAL_CLOSE.icon,
          transition: 'transform 0.1s ease, opacity 0.1s ease',
          transform: active ? 'scale(0.9)' : 'scale(1)',
          opacity: hovered ? 0.85 : 1,
          color: isChip
            ? undefined
            : hovered
              ? SKYX_MODAL_CLOSE.hoverTextColor
              : SKYX_MODAL_CLOSE.iconColor,
        }}
        aria-hidden
      >
        ×
      </span>
    </button>
  );
};
